// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.msg h3[data-v-7760fbe8] {\n  font-size: 20px !important;\n  font-weight: bold !important;\n}\n", ""]);
// Exports
module.exports = exports;
